import request from '@/utils/request'

// 获取启动页详情
export function getStartDetailApi() {
  return request({
    method: 'GET',
    url: 'v1/web/start/detail'
  })
}

// 01获取操作引导页面(无token)

export function getIndexGuideApi(params) {
  return request({
    method: 'get',
    url: `v1/web/index/guide?code=${params}`
  })
}
